/** @jsxImportSource @emotion/react */
import { useTheme } from "@emotion/react";
import React from "react";
import UpdatePasswordForm from "components/MainComponents/ChangePassword/UpdatePasswordForm";
import CommonNavigationBar from "components/MainComponents/NavigationBar/CommonNavigationBar";

export default function ChangePassword() {
  const theme = useTheme();

  return (
    <>
      <div>
        <CommonNavigationBar />
        <UpdatePasswordForm />
      </div>
    </>
  );
}
